/**
 * Copyright (c) 2015-present, Alibaba Group Holding Limited.
 * All rights reserved.
 *
 */
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function merge(one, two) {
  return _extends({}, one, two);
}

module.exports = merge;


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/lib/Navigator/polyfills/merge.js
 **/